import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assests/thas multi tech@2x.png';
import { languagePath } from '../../seo/routes';
import './Navbar.css';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const en = i18n.language.startsWith('en');
  const [open, setOpen] = useState(false);
  const navRef = useRef(null);
  useEffect(() => { setOpen(false); }, [location]);
  useEffect(() => {
    const close = event => { if (navRef.current && !navRef.current.contains(event.target)) setOpen(false); };
    const escape = event => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', close);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('pointerdown', close); document.removeEventListener('keydown', escape); };
  }, []);
  const currentPath = location.pathname + location.search + location.hash;
  return (
    <header className="site-header" ref={navRef}>
      <a className="skip-link" href="#page-content">{en ? 'Skip to content' : 'Hoppa till innehåll'}</a>
      <nav className="site-nav" aria-label={en ? 'Main navigation' : 'Huvudmeny'}>
        <Link className="site-brand" to="/" aria-label="THAS Multitech – start"><img src={logo} width="140" height="75" alt="THAS Multitech AB" /></Link>
        <button className="site-menu-toggle" type="button" onClick={() => setOpen(!open)} aria-controls="site-menu" aria-expanded={open} aria-label={en ? 'Toggle navigation' : 'Öppna eller stäng menyn'}>{open ? '✕' : '☰'}</button>
        <div className={'site-menu' + (open ? ' is-open' : '')} id="site-menu">
          <Link to="/#home" onClick={() => setOpen(false)}>{t('Home')}</Link>
          <Link to="/#services" onClick={() => setOpen(false)}>{t('Services')}</Link>
          <Link to="/3d-printing" className={location.pathname === '/3d-printing' ? 'is-current' : ''} aria-current={location.pathname === '/3d-printing' ? 'page' : undefined} onClick={() => setOpen(false)}>{en ? '3D printing' : '3D-utskrift'}</Link>
          <Link to="/#about" onClick={() => setOpen(false)}>{t('About us')}</Link>
          <Link className="nav-quote" to="/#contact" onClick={() => setOpen(false)}>{en ? 'Request a quote' : 'Be om en offert'} ↗</Link>
          <div className="site-language" aria-label={en ? 'Language' : 'Språk'}>
            <a href={languagePath(currentPath, 'swe')} hrefLang="sv" lang="sv" aria-current={!en ? 'true' : undefined}>Svenska</a>
            <span aria-hidden="true">/</span>
            <a href={languagePath(currentPath, 'en')} hrefLang="en" lang="en" aria-current={en ? 'true' : undefined}>English</a>
          </div>
        </div>
      </nav>
    </header>
  );
}
